// extracted by mini-css-extract-plugin
module.exports = {"accordionTitle":"IngredientsAccordion_accordionTitle__jOps9"};